import { FC } from "react";
import { IconProps } from "@/shared/types/icon";
import { Svg } from "@abel-technologies-as/components";

export const Close: FC<IconProps> = (props) => {
	return (
		<Svg width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
			<path
				d="M12.8338 1.1665L7.00045 6.99984M7.00045 6.99984L1.16711 12.8332M7.00045 6.99984L1.16711 1.1665M7.00045 6.99984L12.8338 12.8332"
				stroke={props.color || "white"}
				strokeWidth="1.66667"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</Svg>
	);
};
